/** @jsx jsx */
import { jsx } from 'theme-ui'

interface IPropsTooltip {
  text: string | undefined | null
  show: boolean
}

const Tooltip: React.FC<IPropsTooltip> = ({ text, show }): JSX.Element => (
  <div
    sx={{
      display: show ? 'block' : 'none',
      backgroundColor: '#34454e',
      position: 'absolute',
      bottom: 'calc(100% + 10px)',
      left: '0',
      right: '0',
      width: 'auto',
      maxWidth: '300px',
      margin: '0 auto',
      padding: '8px',
      textAlign: 'center',
      fontSize: '12px',
      color: '#FFF',
      zIndex: 46,
      borderRadius: '4px',
    }}
  >
    <span
      sx={{
        position: 'absolute',
        bottom: '-8px',
        top: 'auto',
        left: '50%',
        margin: '0 0 0 -10px',
        width: '19px',
        height: '9px',
        backgroundSize: '19px 9px',
      }}
    ></span>
    {text}
  </div>
)

export default Tooltip
